// Envision 3-21-24 - keep quantities of bundle products and their parent products in sync. 
// This function only checks that bundle product quantities match the parent ones, or are removed if the parent is. It does not add new bundle products to the cart, only sets bundle product quantities
// Bundle products must have the '_associatedVariant' property, and parent products should not. Both must the same '_bundleKey' property, which is used to identify all products in a bundle.
// parent_item_properties: {
//   "_bundleKey": SHARED_BUNDLE_ID
// }
// bundle_item_properties: {
//   "_bundleKey": SHARED_BUNDLE_ID,
//   "_associatedVariant": PARENT_VARIANT_ID
// }
(function() {
  function updateBundleQuantities() {
    fetch('/cart.js', {
      credentials: 'same-origin',
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      }
    }).then(function(response) {
      return response.json();
    }).then(function(cart) {
      // process each non-bundle product, then find parent bundle product
      
      var quantityUpdates = {};
      // filter the cart down to only bundle products, and products with related bundle variants/active bundles.
      var filteredCart = cart.items.filter((currentItem) => {
        var valid = false;
        if (typeof currentItem !== 'undefined' && typeof currentItem['properties'] !== 'undefined' && currentItem.properties !== null && currentItem.properties.hasOwnProperty('_bundleKey') && currentItem.properties['_bundleKey'] != '') {
          if (!currentItem.properties.hasOwnProperty('_associatedVariant')) {
            valid = true; // this item is a parent product with a bundle active
          } else if (currentItem.properties['_associatedVariant'] != '' && currentItem.properties['_associatedVariant'] !== 'false') {
            valid = true; // this item is an bundle product
          }
        }
        return valid;
      });

      var parentItems = filteredCart.filter((currentItem) => !currentItem.properties.hasOwnProperty('_associatedVariant'));
      var bundleItems = filteredCart.filter((currentItem) => currentItem.properties.hasOwnProperty('_associatedVariant'));
      var activeBundleKeys = [];
      for (var i=0; i<parentItems.length; i++) {
        activeBundleKeys.push(parentItems[i].properties['_bundleKey']);
      }

      // update bundle product quantities to match parent product quantity.
      for (var i=0; i<parentItems.length; i++) {
        var currentParentItem = parentItems[i];
        var bundleKey = currentParentItem.properties['_bundleKey'];
        var currentBundleItems = bundleItems.filter((currentItem) => currentItem.properties['_bundleKey'] == bundleKey);

        for (var j=0; j<currentBundleItems.length; j++) {
          var currentBundleItem = currentBundleItems[j];
          if (currentBundleItem.quantity !== currentParentItem.quantity) {
            if (!quantityUpdates.hasOwnProperty(currentBundleItem.key)) {
              quantityUpdates[currentBundleItem.key] = currentParentItem.quantity;
            }
          }
        }
      }

      // remove bundle products when their bundleKey property is not attached to a parent product (meaning the parent product has been removed from cart)
      for (var i=0; i<bundleItems.length; i++) {
        var currentBundleItem = bundleItems[i];
        if (!activeBundleKeys.includes(currentBundleItem.properties['_bundleKey'])) {
          if (!quantityUpdates.hasOwnProperty(currentBundleItem.key)) {
              quantityUpdates[currentBundleItem.key] = 0;
            }
        }
      }
      
      // if we have updates to perform, create and submit the request, then trigger a theme cart refresh
      if (Object.keys(quantityUpdates).length !== 0) {
        var requestData = {
          updates: quantityUpdates
        };

        console.log(requestData);
        
        xhook.disable(); // disable xhook listeners when adding these products to avoid recursion

        fetch(`/cart/update.js`, {
          method: "POST",
          body: JSON.stringify(requestData),
          credentials: "same-origin",
          headers: {
            "Content-Type": "application/json",
            "X-Requested-With": "XMLHttpRequest"
          },
        })
        .then(function(response) {
          xhook.enable();
          
          // trigger theme cart update
          // If on cart page, refresh page.
          if (window.location.pathname.includes('/cart')) {
            window.location.href = '/cart';
          } else {
            // method for refreshing the theme cart depends on your theme. We often add a custom event listener to theme scripts that calls the theme's cart refresh functionality when triggered.
            window.dispatchEvent(new Event('triggerCartRefresh', { bubbles: true })); 
          }
        });
      }
    });
  }

  // Listen for all XHR requests that modify the cart items, update on request completion
  // Requires xhook, imported before any other JS files (https://github.com/jpillora/xhook) 
  xhook.after(function(request, response) {
    if (request && (request.url.includes("/cart/add") || request.url.includes("/cart/change") || request.url.includes("/cart/update") || request.url.includes("/cart/clear"))) {
      // uncomment the below line to disable bundle product updates when not on cart page.
      // if (!window.location.pathname.includes('/cart')) return;
      updateBundleQuantities();
    }
  });

  // run update on page load for cart page 
  if (window.location.pathname.includes('/cart')) {
    //updateBundleQuantities();
  }
})();

// Envision 3-21-24 - update total bundle price in lineset-bundle-options component when lineset options change
(function() {
  function updateBundleTotal(element) {
    let linesetTotalElement = element.querySelector('[data-lineset-total][data-product-price]');
    let totalPrice = parseInt(linesetTotalElement.dataset.productPrice, 10);
    let linesetSelects = element.querySelectorAll('.lineset-options-container .lineset-option select');
    for (let i=0; i<linesetSelects.length; i++) {
      if (linesetSelects[i].selectedIndex === 0) continue;
      
      let selectedOption = linesetSelects[i].options[linesetSelects[i].selectedIndex];
      totalPrice += parseInt(selectedOption.dataset.price, 10);
    }
    linesetTotalElement.innerHTML = Shopify.formatMoney(totalPrice);
  }
  
  let linesetBundleElement = document.querySelector('.lineset-bundle-options');
  if (linesetBundleElement !== null) {
    let linesetBundleSelects = linesetBundleElement.querySelectorAll('.lineset-options-container .lineset-option select');
    for (let i=0; i<linesetBundleSelects.length; i++) {
      linesetBundleSelects[i].addEventListener('change', function(e) {
        updateBundleTotal(linesetBundleElement);
      });
    }
    // updateBundleTotal(linesetBundleElement); // also update on page load.
  }
})();

// Envision 04-29-24 - show sticky ATC on PDPs at mobile sizes, update variant price when variant is changed, and trigger click on original ATC button when sticky button is clicked
(function() {
  var stickyAtcElement = document.querySelector('.product--mobile-sticky-atc');
  var stickyScrollTrigger = document.querySelector('[data-sticky-cart-trigger]');
  
  if (
    stickyAtcElement &&
    stickyScrollTrigger &&
    "IntersectionObserver" in window &&
    "IntersectionObserverEntry" in window &&
    "intersectionRatio" in window.IntersectionObserverEntry.prototype
  ) {
    // show sticky ATC when product form is above viewport
    var observerOptions = {};
    var observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        // currently in viewport
        document.body.classList.remove("sticky-atc--active");
        return;
      }
      
      if (entry.boundingClientRect.y > 0) {
        // above viewport
        //document.body.classList.add("sticky-atc--active");
      } else {
        // below viewport
        document.body.classList.add("sticky-atc--active");
      }
    }, observerOptions);
    observer.observe(stickyScrollTrigger);

    // update price in sticky ATC on variant change
    window.addEventListener('variant-change', (e) => {
      let variant = e.detail?.variant ?? false;

      if (variant) {
        let priceElement = stickyAtcElement.querySelector('.price-container .price');
        if (priceElement) {
          priceElement.innerHTML = Shopify.formatMoney(variant.price);
        }
      }
    });
    
    // trigger click on original ATC button when sticky ATC is clicked
    var atcButton = document.querySelector('form[data-product-form] .product-form--atc button[data-product-atc]');
    var stickyAtcButton = stickyAtcElement.querySelector('[data-atc-trigger]');
    if (atcButton && stickyAtcButton) {
      stickyAtcButton.addEventListener('click', function(e) {
        e.preventDefault();
        atcButton.click();
      });
    }
  }
})();